import { render } from "./FacecareTermsOfUseView.vue?vue&type=template&id=7b0fbc54&scoped=true"
import script from "./FacecareTermsOfUseView.vue?vue&type=script&lang=js"
export * from "./FacecareTermsOfUseView.vue?vue&type=script&lang=js"

import "./FacecareTermsOfUseView.vue?vue&type=style&index=0&id=7b0fbc54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0fbc54"]])

export default __exports__